import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { Game, GameFormula } from '../../models/game.model';
import { gameInfoSelectRippleOptions } from '../../constants/ripple-options.constant';
import { sprintf } from '../../functions/format-strings.function';
import { ConfigService } from '../../services/config/config.service';
import { PmuService } from '../../services/data/pmu.service';
import { CurrencyFormatterPipe } from "../../pipes/currency-formatter/currency-formatter.pipe";

@Component({
  selector: 'app-info-games',
  imports: [CommonModule, TranslateModule, MatRippleModule, RouterModule, CurrencyFormatterPipe],
  templateUrl: './info-games.component.html',
  styleUrl: './info-games.component.scss'
})
export class InfoGamesComponent {
  private configService = inject(ConfigService);
  private pmuService = inject(PmuService);
  private translate = inject(TranslateService);
  @Input() games: Game[] = [];
  @Input() selectedGame!: Game;
  @Input() gameFormula: GameFormula = 'SI';
  @Output() selectGame = new EventEmitter<{game: Game, formula: GameFormula , spot: boolean, completeFormula: boolean, multi: number}>();
  @Output() selectSpot = new EventEmitter<{game: Game, formula: GameFormula , spot: boolean, completeFormula: boolean, multi: number}>();
  @Output() voirDetails = new EventEmitter<boolean>();
  isSpot: boolean = false;
  isCompleteFormula: boolean = false;
  rippleOptions = gameInfoSelectRippleOptions
  selectedPartantNo!: number;
  get stepNumber() {
    return 1;
  }
  get gameHasMulti() {
    return  ['MULTIC3', 'PM', 'MM', 'PMM', 'MULTI'].includes(this.selectedGame?.code);
  }

  get gameMultiPartants() {
    switch (this.selectedGame?.code) {
      case "PMM":
        return [4, 5, 6]
    
      default:
        return [4, 5, 6, 7];
    }
  }

  get racePrice() {
    return this.pmuService.getCurrentData().prize;
  }

  get race() {
    return this.pmuService.getCurrentData().race;
  }

  get raceDistanceStr() {
    return `${this.race?.distance ?? 0} m`;
  }

  get horsesCountString() {
    return this.translate.instant('betslip.horses_count', {
      count: this.race?.competitorsCount ?? 0,
    });
  }

  get raceShortNameFormat() {
      return sprintf(
        this.configService.raceShortNameFormat || '',
        this.pmuService.getCurrentData().meeting?.id ?? 0,
        this.pmuService.getCurrentData().race?.id ?? 0
      );
    }
  
  get raceFullNameFormat() {
    return sprintf(
      '%s-%s',
      this.pmuService.getCurrentData().meeting?.name || '',
      this.pmuService.getCurrentData().race?.name || ''
    );
  }

  changeGame(gameIndex: number){
    let currentGame = this.games[gameIndex];

    // Reset the formula to "SI" when changing the game
    this.gameFormula = currentGame.formulas[0];

    this.selectGame.emit({ game: currentGame, formula: this.gameFormula, spot: this.isSpot, completeFormula: this.isCompleteFormula, multi: 0 });
    this.isSpot = false;
    
    setTimeout(() => {
      // Reset the selected multi partant if the game type is not Multi
      const preselectedMultiVal = !this.gameHasMulti ? 0 : this.gameMultiPartants[0];
      this.selectMultiPartant(preselectedMultiVal);
      
    }, 100);
  }

  changeFormula(formula: GameFormula){
    this.gameFormula = formula;
    let game = this.selectedGame;
    if(game){
      this.selectGame.emit({ game , formula: formula, spot: this.isSpot, completeFormula: this.isCompleteFormula, multi: this.selectedPartantNo });
    }
  }

  selectMultiPartant(partant: number) {
    this.selectedPartantNo = partant;
    let game = {
      ...this.selectedGame,
      baseHorseCount: this.gameHasMulti ? partant : this.selectedGame.baseHorseCount
    };

   this.selectGame.emit({ game: game, formula: this.gameFormula, spot: this.isSpot, completeFormula: this.isCompleteFormula, multi: this.selectedPartantNo });
  }

  toggleSpot(){
    if(this.selectedGame && this.selectedGame.spot.enabled){
      this.isSpot = !this.isSpot;
      this.gameFormula = 'SI';
      this.selectSpot.emit({ game: this.selectedGame, formula: this.gameFormula, spot: this.isSpot, completeFormula: this.isCompleteFormula, multi: this.selectedPartantNo });

      // Emit event to open voirDetails
      if (this.isSpot) {
        // this.voirDetails.emit(true);
      }
    }
  }
}
